// import { Modal } from "@/components/molecules/Modals/ModalController";
// import { storeSignupContext } from "@/functions/signupTracking";
import { createSlice } from "@reduxjs/toolkit";
/**
 * The dialogs either app can raise from anywhere, by dispatching `showDialog`.
 *
 * Both apps' message slices are named "message", so the action type this
 * produces (`message/showDialog`) is handled by whichever of the two is
 * mounted. That is what lets shared code — `clubImportPrompt`, the 402
 * backstop — open a dialog without knowing which app it is running in, and it
 * is why the two slices have to be renamed together.
 */
/**
 * The slice name, and therefore the prefix of every action type it produces.
 *
 * Both apps' message slices must use this exact value: shared code dispatches
 * `showDialog` and the resulting `message/showDialog` is handled by whichever
 * reducer is mounted. Renaming one slice alone would stop the 402 gate opening
 * with no compile error and nothing in the logs, so the string is a constant
 * both imports rather than a literal each writes out.
 */
export const MESSAGE_SLICE_NAME = "message";
const initialState = {
    message: null,
    modal: null,
    dialog: null,
    alerts: [],
};
const messageSlice = createSlice({
    name: MESSAGE_SLICE_NAME,
    initialState,
    reducers: {
        setMessage(state, action) {
            state.message = action.payload;
        },
        clearMessage(state) {
            state.message = null;
        },
        showModal(state, action) {
            // Modal | null
            if (!state.modal) {
                state.modal = action.payload;
                // Store signup context when showing login-required modal
                if (action.payload?.modalType === "login-required") {
                    const trigger = action.payload.freeFeatureLoggedInRequiredHook || "login-required";
                    // storeSignupContext(trigger);
                }
                else if (action.payload?.modalType === "sign-in-to-subscribe") {
                    // storeSignupContext("sign-in-to-subscribe");
                }
            }
            else {
                state.modal = null;
            }
        },
        showDialog(state, action) {
            state.dialog = action.payload;
        },
        hideDialog(state) {
            state.dialog = null;
        },
        addAlert(state, action) {
            const alert = {
                ...action.payload,
                id: action.payload.title + action.payload.description + Date.now(),
            };
            state.alerts = [...state.alerts, alert];
        },
        removeAlert(state, action) {
            // state.alerts = state.alerts.filter(
            //   (alert) => alert.id !== action.payload,
            // );
        },
    },
});
export const getMessageSelector = (state) => state.messageReducer;
export const dialogSelector = (state) => state.messageReducer.dialog;
export const { setMessage, clearMessage, showModal, showDialog, hideDialog, addAlert, removeAlert, } = messageSlice.actions;
export default messageSlice.reducer;
//# sourceMappingURL=messageSlice.js.map